import { createBrowserRouter, Navigate } from "react-router-dom";
import { RequireAuth } from "./auth/require-auth";
import { RequireOnboarded } from "./auth/require-onboarded";
import { LandingPage } from "./landing/landing-page";
import { LoginPage } from "./auth/login-page";
import { ImpressumPage, PrivacyPage, SupportPage, TermsPage } from "./legal/legal-pages";
import { RegisterPage } from "./auth/register-page";
import { OnboardingPage } from "./auth/onboarding/onboarding-page";
import { InviteRedeemPage } from "./auth/invite-redeem-page";
import { ForgotPasswordPage } from "./auth/forgot-password-page";
import { ResetPasswordPage } from "./auth/reset-password-page";
import { VerifyEmailPage } from "./auth/verify-email-page";
import { RequireAdmin } from "./auth/require-admin";
import { AdminPage } from "./app/admin-page";
import { AppShell } from "./app/app-shell";
import { DashboardPage } from "./app/dashboard-page";
import { StatsPage } from "./stats/stats-page";
import { CreateGallery } from "./create/create-gallery";
import { FrameworkDetailPage } from "./create/framework-detail";
import { RunPage } from "./create/run-page";
import { PlacementPlay } from "./create/placement-play";
import { LibraryList } from "./library/library-list";
import { SetDetailPage } from "./library/set-detail";
import { PlaySession } from "./practice/play-session";
import { TrainPage } from "./train/train-page";
import { TrainPlay } from "./train/train-play";
import { CommunityPage } from "./community/community-page";
import { ClanDetailPage } from "./community/clan-detail";
import { JoinClassPage } from "./community/join-class-page";
import { CoopSessionPage } from "./community/coop-session";
import { CalendarPage } from "./calendar/calendar-page";
import { ProfilePage } from "./profile/profile-page";
import { SettingsPage } from "./settings/settings-page";
import { StudyLibrary } from "./study/study-library";
import { StudyStart } from "./study/study-start";
import { StudyPage } from "./study/study-page";
import { ProjectsListPage } from "./projects/projects-list";
import { ProjectCreatePage } from "./projects/project-create";
import { ProjectDetailPage } from "./projects/project-detail";
import { ProjectMarkingPage } from "./projects/project-marking";
import { ProjectReportPage } from "./projects/report/project-report-page";
import { PresentationPage } from "./projects/presentation/presentation-page";
import { PresentationPlanPage } from "./projects/presentation-plan/presentation-plan-page";

export const router = createBrowserRouter([
  { path: "/", element: <LandingPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "/support", element: <SupportPage /> },
  { path: "/impressum", element: <ImpressumPage /> },
  { path: "/legal", element: <Navigate to="/impressum" replace /> },
  { path: "/register", element: <RegisterPage /> },
  { path: "/invite/:token", element: <InviteRedeemPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password/:token", element: <ResetPasswordPage /> },
  { path: "/verify-email/:token", element: <VerifyEmailPage /> },
  {
    path: "/onboarding",
    element: (
      <RequireAuth>
        <OnboardingPage />
      </RequireAuth>
    ),
  },
  {
    path: "/app",
    element: (
      <RequireAuth>
        <RequireOnboarded>
          <AppShell />
        </RequireOnboarded>
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "train", element: <TrainPage /> },
      { path: "train/play", element: <TrainPlay /> },
      { path: "create", element: <CreateGallery /> },
      { path: "create/run/:runId", element: <RunPage /> },
      { path: "create/placement", element: <PlacementPlay /> },
      { path: "create/:slug", element: <FrameworkDetailPage /> },
      { path: "projects", element: <ProjectsListPage /> },
      { path: "projects/new", element: <ProjectCreatePage /> },
      { path: "projects/:projectId", element: <ProjectDetailPage /> },
      { path: "projects/:projectId/mark", element: <ProjectMarkingPage /> },
      { path: "projects/:projectId/report", element: <ProjectReportPage /> },
      { path: "projects/:projectId/presentation", element: <PresentationPage /> },
      { path: "projects/:projectId/presentation-plan", element: <PresentationPlanPage /> },
      { path: "study", element: <StudyLibrary /> },
      { path: "study/new", element: <StudyStart /> },
      { path: "study/:pdfRef", element: <StudyPage /> },
      { path: "library", element: <LibraryList /> },
      { path: "library/:setId", element: <SetDetailPage /> },
      { path: "library/:setId/play", element: <PlaySession /> },
      { path: "community", element: <CommunityPage /> },
      { path: "community/join/:code", element: <JoinClassPage /> },
      { path: "community/clans/:clanId", element: <ClanDetailPage /> },
      { path: "coop/:coopId", element: <CoopSessionPage /> },
      { path: "calendar", element: <CalendarPage /> },
      { path: "profile", element: <ProfilePage /> },
      { path: "stats", element: <StatsPage /> },
      { path: "settings", element: <SettingsPage /> },
      {
        path: "admin",
        element: (
          <RequireAdmin>
            <AdminPage />
          </RequireAdmin>
        ),
      },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
